module.exports = __webpack_public_path__ + "img/23.e8f9c1d5.png";